export const pickerStyles = {
  default: {
    picker: {
      width: '100%',
      boxShadow: 'none',
      marginTop: 20,
      borderRadius: 6,
    },
    saturation: {
      borderRadius: 6,
    },
    hue: {
      height: 16,
      borderRadius: 6,
    },
    Hue: {
      borderRadius: '6px',
    },
    controls: {
      borderRadius: 6,
    },
    body: {
      padding: '16px 0',
    },
    color: {
      display: 'none',
    },
    alpha: {
      display: 'none',
    },
  },
};

export const ERROR_MESSAGE = 'Please write a valid color.';
